// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ONOo","questions":"styles_questions__14C3l","footer":"styles_footer__3maJO"};